import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Set target date to July 9, 2025 at 23:59
    const targetDate = new Date(2025, 6, 9, 23, 59, 59); // Month is 0-indexed, so 6 = July
    
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;
      
      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="mb-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-gradient-to-r from-slate-800/60 to-slate-700/60 rounded-2xl p-6 border border-amber-500/30 backdrop-blur-md"
      >
        <div className="text-center mb-4">
          <span className="text-amber-400 text-lg font-semibold">⏰ เหลืออีก</span>
        </div>
        
        <div className="flex justify-center items-center gap-4">
          {/* Days */}
          <div className="text-center">
            <div className="bg-gradient-to-br from-amber-500 to-yellow-600 rounded-xl p-4 min-w-[80px] border border-amber-400/50 shadow-lg">
              <div className="text-white font-bold text-3xl md:text-4xl">{timeLeft.days}</div>
            </div>
            <div className="text-amber-300 text-sm font-medium mt-2">วัน</div>
          </div>
          
          {/* Separator */}
          <div className="text-amber-400 text-2xl font-bold animate-pulse">:</div>
          
          {/* Hours */}
          <div className="text-center">
            <div className="bg-gradient-to-br from-amber-500 to-yellow-600 rounded-xl p-4 min-w-[80px] border border-amber-400/50 shadow-lg">
              <div className="text-white font-bold text-3xl md:text-4xl">{timeLeft.hours}</div>
            </div>
            <div className="text-amber-300 text-sm font-medium mt-2">ชั่วโมง</div>
          </div>
          
          {/* Separator */}
          <div className="text-amber-400 text-2xl font-bold animate-pulse">:</div>
          
          {/* Minutes */}
          <div className="text-center">
            <div className="bg-gradient-to-br from-amber-500 to-yellow-600 rounded-xl p-4 min-w-[80px] border border-amber-400/50 shadow-lg">
              <div className="text-white font-bold text-3xl md:text-4xl">{timeLeft.minutes}</div>
            </div>
            <div className="text-amber-300 text-sm font-medium mt-2">นาที</div>
          </div>
          
          {/* Separator */}
          <div className="text-amber-400 text-2xl font-bold animate-pulse">:</div>
          
          {/* Seconds */}
          <div className="text-center">
            <div className="bg-gradient-to-br from-red-500 to-orange-600 rounded-xl p-4 min-w-[80px] border border-red-400/50 shadow-lg animate-pulse">
              <div className="text-white font-bold text-3xl md:text-4xl">{timeLeft.seconds}</div>
            </div>
            <div className="text-red-300 text-sm font-medium mt-2">วินาที</div>
          </div>
        </div>
        
        {/* Additional urgency text */}
        <div className="text-center mt-4">
          <p className="text-slate-300 text-sm">
            ก่อนปิดรับสมัคร <span className="text-red-400 font-semibold">9 กรกฎาคม 2568</span>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default CountdownTimer;